import React from 'react'
import './cta.css'

const Cta = () => {
  return (
    <div className='lumoz__cta'>
      <div className='lumoz__cta-content'>
        <h3>Lumoz 1.0 Beta Release Coming Soon !</h3>
      </div>
      <div className='lumoz__cta-btn'>
        <a href='#whatLumoz'>
          <button type='button'>Scroll Down for More Info </button>
        </a>
      </div>
    </div>
  )
}

export default Cta
